import instance from "../../../services/api";

export const jurDateWarrantyReportAPI = {
  async getData(body = {}) {
    return await instance(true)
      .post("/partner/report/jur_date_warranty/", body)
      .then(res => res?.data);
  },
};
